import { ApolloCache, gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';
import { goalFragment } from '../fragments/goal';
import { GetQuestsQuery, GetQuestsQueryVariables, UpdateCategoryMutation } from '../generated/graphql';
import { getQuestsQuery } from '../queries/quest';

export const updateCategoryMutation = gql`
    ${categoryFragment}
    ${goalFragment}

    mutation UpdateCategory(
        $categoryId: String!
        $name: String!
        $description: String
        $icon: String!
        $iconColor: String!
        $parentId: String
        $goalEnabled: Boolean
    ) {
        updateCategory(
            data: {
                id: $categoryId
                name: $name
                description: $description
                icon: $icon
                iconColor: $iconColor
                parentId: $parentId
                goalEnabled: $goalEnabled
            }
        ) {
            category {
                ...CategoryFields
            }
            goal {
                ...GoalFields
            }
        }
    }
`;

export function updateCategoryCache(cache: ApolloCache<any>, { data: data }: { data?: UpdateCategoryMutation | null }) {
    const oldData = cache.readQuery<GetQuestsQuery, GetQuestsQueryVariables>({ query: getQuestsQuery });
    if (!oldData?.goals || !data?.updateCategory) return;

    let updatedGoals = oldData.goals || [];

    if (data.updateCategory.goal) {
        const updatedGoal = data.updateCategory.goal;
        const existingGoal = updatedGoals.find(goal => goal.id === updatedGoal.id);

        if (existingGoal) updatedGoals = updatedGoals.map(goal => (goal.id === updatedGoal.id ? updatedGoal : goal));
        else updatedGoals = [...updatedGoals, updatedGoal];
    }

    cache.writeQuery<GetQuestsQuery, GetQuestsQueryVariables>({
        query: getQuestsQuery,
        data: { ...oldData, goals: updatedGoals },
    });
}
